<template>
  <div :class="['terms-of-service-content', {
    'sm': sm
  }]">
    <h1 class="heading">
      Sharewind（シェアウィンド）<br>利用規約
    </h1>
    <div class="article">
      <div class="article-title">第1条（用語の定義）</div>
      <div class="article-body">
        <div>本利用規約における主な用語の定義は、次の各号に掲げるとおりとします。</div>
        <ol class="right-brackets">
          <li>「Sharewindサービス（以下「本サービス」といいます。）」とは、岩崎通信機株式会社（以下「当社」といいます。）がインターネット上で提供するクラウド型サービスのことをいいます。</li>
          <li>「本サイト」とは、本サービスに関して当社が運営するウェブサイトのことをいいます。</li>
          <li>「利用契約」とは、当社から本サービスの提供を受けるための契約をいいます。</li>
          <li>「契約者」とは、本利用規約に基づいて当社と利用契約を締結している個人、法人又は団体をいいます。</li>
          <li>「プラン」とは、利用人数上限、利用できる機能、利用料金が異なる利用形態をいい、フリープラン、スタンダードプラン、プロフェッショナルプラン、エンタープライズプランがあります。契約者はこれらのプランの中から1つを選択して契約するものとします。プランの詳細は別途定めます。</li>
          <li>「利用者」とは、本利用規約に基づいて、本サービスを利用することを契約者から認められた者をいいます。</li>
          <li>「管理者」は、利用者を管理するために契約者から指定された利用者をいいます。管理者は当社との連絡窓口となります。</li>
          <li>「ゲスト」とは、利用者のうち、プロジェクト、チャット、会議に参加するのみで、会議予約、チャットグループ作成、プロジェクト作成の権限を有しない者として管理者から指定された者をいいます。</li>
          <li>「月間契約」とは、本サービスの1ヶ月分のご利用料金をお支払いいただき開始された本サービスの月単位での契約をいい、フリープランを除くスタンダードプラン、プロフェッショナルプランおよびエンタープライズプランが該当します。</li>
          <li>「ライセンス」とは、利用者として登録可能な資格をいいます。</li>
        </ol>
      </div>
    </div>
    <div class="article">
      <div class="article-title">第2条（規約の適用および変更）</div>
      <div class="article-body">
        <ol>
          <li>本利用規約は、全ての契約者および利用者に適用されます。本利用規約に同意いただけない場合、本サービスを利用することはできません。</li>
          <li>本サイト上で、本サービスに関する本利用規約以外の規定（以下「その他の規定」といいます。）が存在する場合に、その他の規定は、本利用規約の一部を構成するものとします。本利用規約の規定とその他の規定の内容が異なる場合は、本利用規約が優先して適用されます。</li>
          <li>契約者は、利用者が本サービスの利用を開始する際に、本利用規約の内容を説明し遵守させる責任があります。</li>
          <li>当社は、本利用規約をいつでも任意に変更することができ、契約者はこれを承諾するものとします。当社が別途定める場合を除き、本利用規約の変更は、本サイトへの掲載によって随時発表するものとし、当該掲載をもって効力が生じます。契約者が本利用規約の変更を同意しない場合、契約者の唯一の対処方法は、第18条所定の解約手続きによって契約を終了させることだけです。</li>
          <li>本利用規約が変更された場合、契約者に、変更後の利用規約について承諾を求めることがあります。</li>
        </ol>
      </div>
    </div>
    <div class="article">
      <div class="article-title">第3条（本サービスの提供）</div>
      <div class="article-body">
        <ol>
          <li>
            <span>当社は、契約者に対し、本サービスを提供いたします。本サービスにおける</span>
            <router-link :to="{ name: 'servicePlans' }" target="_blank">各プラン</router-link>
            <span>のサービスの具体的内容は、別途定めるプラン比較ページの内容によります。</span>
          </li>
          <li>契約者は、自らの責任と費用において、ハードウェア、ソフトウェア、インターネット接続回線、セキュリティの確保等、本サービスの利用に必要な環境（以下「利用環境」といいます。）を整備します。</li>
        </ol>
      </div>
    </div>
    <div class="article">
      <div class="article-title">第4条（知的財産権等）</div>
      <div class="article-body">
        <ol>
          <li>プログラム、サービス提供画面等、本サービスに関する一切の特許権、実用新案権、意匠権、商標権、著作権、不正競争防止法上の権利、その他一切の財産的もしくは人格的権利（以下「知的財産権等」といいます。）は、全て当社又はそのライセンサーに帰属します。</li>
          <li>契約者は、本サービスの利用契約締結に基づいて、本サービスを利用することができますが、提供される本サービスに関する知的財産権等を取得するものではありません。</li>
        </ol>
      </div>
    </div>
    <div class="article">
      <div class="article-title">第5条（利用資格）</div>
      <div class="article-body">20歳未満の方が本サービスの利用契約を申し込む際には、事前に親権者の同意を得るものとします。</div>
    </div>
    <div class="article">
      <div class="article-title">第6条（契約期間）</div>
      <div class="article-body">
        <ol>
          <li>
            <span>契約成立と利用開始日について</span>
            <div>本サービス利用申し込みをいただき、当社からオンラインの会員専用画面において本サービス利用開始日を表示することをもって、当社が申し込みを受諾したものとし、契約成立となります。</div>
          </li>
          <li>
            <span>試用期間について</span>
            <div>スタンダードプラン、プロフェッショナルプランおよびエンタープライズプランについては、いずれかのプランに初回申し込み日から当月末迄を試用期間とします。</div>
          </li>
          <li>
            <span>フリープランの契約期間</span>
            <div>フリープランの契約期間は、利用開始日から本サービスの最終利用日より1年を経過する日までとします。</div>
          </li>
          <li>
            <span>スタンダードプラン、プロフェッショナルプランおよびエンタープライズプランの契約期間</span>
            <div>スタンダードプラン、プロフェッショナルプランおよびエンタープライズプランの契約期間は、特段の合意がない限り月間契約とし、契約成立時に会員専用画面において表示される利用開始日から当月末迄とします。</div>
          </li>
          <li>
            <span>契約の自動更新</span>
            <div>スタンダードプラン、プロフェッショナルプランおよびエンタープライズプランの契約については、契約者から当社に対し、契約期間満了日までに第18条第2項所定の解約手続きによって契約を終了させる旨の申し出がなされない限り1ヶ月間自動更新されるものとし、その後も同様とします。</div>
          </li>
          <li>
            <span>基準時間</span>
            <div>本利用規約にて定める日時は、全て日本時間を基準とします。</div>
          </li>
        </ol>
      </div>
    </div>
    <div class="article">
      <div class="article-title">第7条（プランの変更）</div>
      <div class="article-body">
        <div>以下の各号に該当する契約者は、当社に対し、各号記載のとおり、プラン変更を申し込むことができます。</div>
        <ol class="right-brackets">
          <li>
            <span>フリープラン契約者</span>
            <div>スタンダードプラン、プロフェッショナルプラン又はエンタープライズプランへのプラン変更を申し込むことができます。</div>
          </li>
          <li>
            <span>スタンダードプラン契約者</span>
            <div>フリープラン、プロフェッショナルプラン又はエンタープライズプランへのプラン変更を申し込むことができます。</div>
          </li>
          <li>
            <span>プロフェッショナルプラン契約者</span>
            <div>フリープラン、スタンダードプラン又はエンタープライズプランへのプラン変更を申し込むことができます。</div>
          </li>
          <li>
            <span>エンタープライズプラン契約者</span>
            <div>フリープラン、スタンダードプラン又はプロフェッショナルプランへのプラン変更を申し込むことができます。</div>
          </li>
        </ol>
      </div>
    </div>
    <div class="article">
      <div class="article-title">第8条（ライセンス）</div>
      <div class="article-body">
        <ol>
          <li>契約者は、契約したライセンスの数の範囲内で、複数の利用者を（1ライセンスにつき一意の一人について）登録することができます。ライセンスが適用される利用者を変更（すなわち、既存の利用者の登録を削減し、別の方を利用者として登録）することはできますが、１ライセンスにつき同時に複数の方を利用者として登録することはできません。</li>
          <li>利用者は、契約期間内において契約者によって登録されている間、本サービスを利用することができます。</li>
          <li>管理者は、利用者のうち任意の者をゲストとして指定することができます。</li>
          <li>フリープラン以外の契約者は、いつでも、ライセンスの追加、削減を申し込むことができます。契約者がライセンスの数の追加、削減の申し込みを行った時点で、申し込み完了となります。</li>
        </ol>
      </div>
    </div>
    <div class="article">
      <div class="article-title">第9条（認証・パスワード管理等）</div>
      <div class="article-body">
        <ol>
          <li>本サービスを利用するにあたっては、メールアドレスおよびパスワードの登録が必要となります。</li>
          <li>契約者および利用者は、登録したメールアドレスおよびパスワードを厳重に管理するものとし、第三者に知られないようにしなければなりません。第三者にパスワードを知られたと感じる場合には、直ちにパスワードを変更するものとします。</li>
          <li>当社は、契約者又は利用者のものとして登録されたメールアドレスおよびパスワードの入力によりログインされ、本サービスが利用されているときは、当該契約者又は利用者本人が本サービスを利用しているものとみなします。</li>
        </ol>
      </div>
    </div>
    <div class="article">
      <div class="article-title">第10条（利用料金）</div>
      <div class="article-body">
        <ol>
          <li>
            <span>本サービスの利用にあたり、契約者は、以下各号に定めるところに従い、利用料金を支払うものとします。</span>
            <ol class="right-brackets">
              <li>
                <span>サービス利用料金</span>
                <div>
                  <span>本サービスの利用料金は、別途定める</span>
                  <router-link :to="{ name: 'servicePlans' }" target="_blank">プラン比較ページ</router-link>
                  <span>の内容に従うものとします。</span>
                </div>
              </li>
              <li>
                <span>フリープラン以外のプランにおけるライセンス数の追加、削除に伴う利用料金の変更</span>
                <div>ライセンスを追加又は削除した場合の利用料金の変更については、各プランのライセンス利用料金の内容に従うものとします。</div>
              </li>
              <li>
                <span>お支払い方法</span>
                <div>請求書払い又はクレジットカード決済のみご利用できます。</div>
              </li>
              <li>
                <span>利用料金の発生</span>
                <div>各プランの利用開始および変更、並びに追加機能利用のお申し込みが完了したときから利用料金が発生します。なお、契約更新時は決済処理が完了した日ではなく、契約更新日より料金が発生します。契約更新は第6条に従って、適用されます。</div>
              </li>
              <li>
                <span>お支払日</span>
                <div>お支払日は、請求書に記載のお支払日、又は各クレジット会社会員規約に基づく引き落とし日となります。</div>
              </li>
            </ol>
          </li>
          <li>
            <span>料金支払いについてのご注意</span>
            <div>ご利用月の各プランの利用料金および追加機能の利用料金は、前月末時点のご利用状況を基準としてご請求いたします。契約者は、利用の有無にかかわらず、期間中の利用料金全額を支払うものとします。月の途中でプランを変更し、もしくは追加機能を増加又は減少した場合においては、ご利用月における最も高額なプラン、および最も多く指定された追加機能の１ヶ月分の利用料金を適用するものとし、前月末を基準とした利用料金との差額は翌月に精算するものとします。クレジットカード会社、収納代行会社、金融機関などで別途利用条件（支払期日、与信限度額等）の設定がある場合には、それらに規定する契約条件に従うものとします。</div>
          </li>
          <li>
            <span>料金の改定について</span>
            <div>当社は、契約者の承諾なく利用料金額を改定又は部分的変更を行うことができるものとし、契約者は、改定後の利用料金を当社指定の方法で支払うものとします。</div>
          </li>
          <li>
            <span>お支払いの遅延について</span>
            <div>当社指定の支払い方法にて利用料金の決済処理ができなかった場合、第16条又は第22条に従い、サービスの停止又は解除の手続きを取れる場合があります。</div>
          </li>
        </ol>
      </div>
    </div>
    <div class="article">
      <div class="article-title">第11条（届出事項の変更）</div>
      <div class="article-body">契約者は、本サービスお申し込み時に当社へ届け出た事項に変更が生じた場合、当社所定のオンライン上の方法を通じて、変更内容をすみやかに届け出るものとします。</div>
    </div>
    <div class="article">
      <div class="article-title">第12条（連絡について）</div>
      <div class="article-body">
        <ol>
          <li>当社から契約者への連絡は、管理者への書面の送付、メールの送信、又は本サイトへの掲載等、当社が適当と判断する通信手段によって行います。当該連絡が、メールの送信又は本サイトへの掲載によって行われる場合は、インターネット上に配信された時点で契約者に到達したものとします。</li>
          <li>契約者から当社への連絡は、本サイト上のメールフォームからの管理者によるメールの送信にて行うものとします。当社は、上記以外の手段による契約者からの連絡については、対応しないものとします。</li>
        </ol>
      </div>
    </div>
    <div class="article">
      <div class="article-title">第13条（個人情報の取り扱いに関して）</div>
      <div class="article-body">
        <span>当社は、契約者又は利用者の個人情報（氏名、住所、電話番号、メールアドレス等）を、プライバシーポリシー（</span>
        <a href="https://www.iwatsu.co.jp/security/" target="_blank">https://www.iwatsu.co.jp/security/</a>
        <span>）に基づき、適切に取り扱います。</span>
      </div>
    </div>
    <div class="article">
      <div class="article-title">第14条（本サービス内容の変更）</div>
      <div class="article-body">当社は、契約者への事前の通知なくして、本サービス各プランの諸条件、価格、本サービスの部分的な改廃など、本サービスの内容を変更することがあり、契約者は、これを承諾するものとします。</div>
    </div>
    <div class="article">
      <div class="article-title">第15条（サービスの中断）</div>
      <div class="article-body">
        <div>当社は以下の各号の一に該当する場合には、契約者に事前に連絡することなく、一時的に本サービスの提供を中断する場合があります。契約者は、このことを了解の上ご利用ください。</div>
        <ol class="right-brackets">
          <li>本サービスのシステムの保守を定期的に、又は緊急に行う場合</li>
          <li>火災、停電、事故などにより本サービスの提供ができなくなった場合</li>
          <li>地震、噴火、洪水、津波などの天災により本サービスの提供ができなくなった場合</li>
          <li>戦争、変乱、暴動、騒乱、労働争議などにより本サービスの提供ができなくなった場合</li>
          <li>予想外の技術的問題</li>
          <li>その他、運用上、技術上、当社が本サービスの一時的な中断を必要と判断した場合</li>
        </ol>
      </div>
    </div>
    <div class="article">
      <div class="article-title">第16条（契約者の都合によるサービスの停止）</div>
      <div class="article-body">
        <div>当社は、契約者に、以下各号に定める停止事由が存する場合、各号に定める再開事由が生じるまでの間、サービスの提供を停止することがあります。</div>
        <ol class="right-brackets">
          <li>
            <span>（停止事由）</span>
            <div>当社指定の支払い方法にて利用料金の決済処理ができないこと</div>
            <span>（再開事由）</span>
            <div>未払い利用料金全額の入金が確認されること</div>
          </li>
          <li>
            <span>（停止事由）</span>
            <div>未払い利用料金が発生し、かつ、当社から契約者に連絡が取れないこと</div>
            <span>（再開事由）</span>
            <div>契約者に連絡が取れ、かつ、未払い利用料金全額の入金が確認されたこと</div>
          </li>
          <li>
            <span>（停止事由）</span>
            <div>当社から管理者に連絡を取れる必要がある場合において、当該管理者に連絡が取れないこと</div>
            <span>（再開事由）</span>
            <div>当該管理者に連絡が取れること</div>
          </li>
          <li>
            <span>（停止事由）</span>
            <div>第21条に違反した場合において、違反状態が是正されないこと</div>
            <span>（再開事由）</span>
            <div>第21条の違反状態が是正されること</div>
          </li>
        </ol>
      </div>
    </div>
    <div class="article">
      <div class="article-title">第17条（本サービスの廃止）</div>
      <div class="article-body">
        <ol>
          <li>当社は、やむをえない事由が発生した場合には、本サービスの契約を終了させ、又は本サービスの提供を廃止することがあります。</li>
          <li>本サービスを廃止する場合には、あらかじめ、ウェブサイトにおける告知その他適宜の方法により契約者に通知いたします。ただし、緊急その他やむをえない事情がある場合はこの限りでありません。</li>
        </ol>
      </div>
    </div>
    <div class="article">
      <div class="article-title">第18条（契約者による解約）</div>
      <div class="article-body">
        <div>契約者は、当該契約期間満了日までに当社所定のオンライン上の解約ページにより解約を申し出ることにより、本サービスの利用契約を解約できるものとします。</div>
        <div>解約手続きが完了した場合には、オンライン上の解約完了画面においてその旨表示するとともに、管理者のメールアドレス宛に通知をいたします。</div>
        <div>契約期間の途中の解約や利用日数の有無にかかわらず、当社が規定した契約期間分の料金は、全額お支払いいただくものとし、既にお支払いいただいた利用料金がある場合でも当社から契約者への返金は致しません。</div>
      </div>
    </div>
    <div class="article">
      <div class="article-title">第19条（返金・キャンセル）</div>
      <div class="article-body">
        <ol>
          <li>契約者は、第18条（契約者による解約）の場合を除き、契約締結後の申し込みみの撤回（キャンセル）はできません。</li>
          <li>前項の規定にかかわらず、当社が契約者の申し込み内容と異なるサービスを契約者に提供し、契約者が電子メール又は当社が提供する手段を通じて当社へ連絡したにも拘わらず当社がこれを是正できなかった場合、契約者は申し込みの撤回・キャンセルをすることができます。</li>
          <li>前項の規定によりキャンセルがされた場合、当社は、銀行振込又はクレジットカード決済の取り消しにより、返金いたします。</li>
        </ol>
      </div>
    </div>
    <div class="article">
      <div class="article-title">第20条（権利義務の譲渡）</div>
      <div class="article-body">
        <ol>
          <li>当社は、契約者に対する債権を第三者に譲渡できるものとし、契約者は、そのために契約者の個人情報等が当該第三者に提供されることを承諾するものとします。</li>
          <li>契約者は、当社の事前の書面による承諾なく、本契約上の地位又は本サービスに基づく権利義務につき、第三者に対し、譲渡、移転、担保設定、その他の処分をすることはできないこととします。ただし、当社が事前に書面による承諾をした場合は、この限りでありません。</li>
        </ol>
      </div>
    </div>
    <div class="article">
      <div class="article-title">第21条（禁止事項）</div>
      <div class="article-body">
        <div>契約者又は利用者は、本サービスの利用に際して、故意又は過失の有無にかかわらず、自ら、又は第三者を利用して、以下各号に該当する行為をしてはならないものとします。</div>
        <ol class="right-brackets">
          <li>承諾を得ることなく他人の著作物やその複製物を送信する行為、他人のプライバシーや企業秘密に属する事項を送信する行為など、当社もしくは第三者の著作権、商標権等の知的財産権、財産、プライバシーもしくは肖像権を侵害する行為、又はそのおそれのある行為。</li>
          <li>当社、もしくは第三者に不利益又は損害を与える行為、又はそのおそれのある行為。</li>
          <li>第三者の人権を侵害する行為ないし公序良俗に反する行為、又はそのおそれのある行為。</li>
          <li>詐欺・脅迫など犯罪実行の手段や、犯罪の教唆・扇動のために本サービスを利用するなど、犯罪的行為もしくは犯罪的行為に結びつく行為、又はそのおそれのある行為。</li>
          <li>当社サーバーに極度の負荷をかけるような態様で本サービスを使用するなど、当社もしくは本サービスの運営を妨げる行為、又はそのおそれのある行為。</li>
          <li>当社もしくは本サービスの信用を毀損する行為、又はそのおそれのある行為。</li>
          <li>当社に対して虚偽の申告、届出をする行為。</li>
          <li>本サービスを通じて、又は本サービスに関連してコンピュータウィルス等、有害なプログラムを使用、又は提供する行為、又はそのおそれのある行為。</li>
          <li>法令に違反する行為。</li>
          <li>利用者のものとして登録したメールアドレスおよびパスワードを、当該利用者以外の第三者に入力させて本サービスを利用させる行為。</li>
          <li>当社の事前の書面による同意なく第三者へ本サービス利用契約上の地位を貸与、譲渡する行為。</li>
          <li>本サービスの一部又は全部をリバースエンジニアリング、逆コンパイル、又は逆アセンブラ、その他本サービスを解析する行為。</li>
          <li>反社会的勢力等（暴力団、暴力団員、右翼団体、反社会的勢力、その他これに準ずる者を意味します。以下同じ。）の維持、運営もしくは経営に協力もしくは関与する等反社会的勢力等との何らかの交流もしくは関与をする行為。</li>
          <li>他の利用者への無差別なコンタクト申請、その他本サービスの利用者に迷惑をかける行為。</li>
          <li>ハードウェア又はソフトウェアの管理を無効にする等、ハードウェア又はソフトウェアのメーカーが定める利用規約、ガイドライン、その他の規定類で定められた使用条件に違反して改造されたデバイスを使って、本サービスを利用する行為。</li>
          <li>前各号の行為を直接又は間接に惹起し又は容易にする行為。</li>
          <li>その他、当社が不適当であると判断する行為。</li>
        </ol>
      </div>
    </div>
    <div class="article">
      <div class="article-title">第22条（当社による解除）</div>
      <div class="article-body">
        <ol>
          <li>当社は、契約者又は利用者が、前条各号、その他本利用規約に定める条項に違反した場合においては、契約者の帰責性の有無にかかわらず、あらかじめ契約者に通知することなく、即時に当該利用契約を解除することができます。</li>
          <li>前項の規定によって当該利用契約が解除された場合、既に支払われた利用代金は返金いたしません。</li>
        </ol>
      </div>
    </div>
    <div class="article">
      <div class="article-title">第23条（データの閲覧・利用・開示・削除に関する合意事項）</div>
      <div class="article-body">
        <ol>
          <li>当社は、契約者又は利用者が登録時に入力した情報（以下「ユーザー情報」といいます。）、および、チャット・タスク・ファイルなど利用者が送信した情報（以下「送信情報」といいます。）について、細心の注意を払い、安全に管理するよう努めます。</li>
          <li>利用者は、送信情報に係る著作権を、送信後も引き続き保有します。当社は、契約者又は利用者に対する本サービスの提供のために必要な範囲に限って、送信情報を複製、翻案、自動公衆送信およびそのために必要な送信可能化その他の利用を行うことができるものとします。</li>
          <li>第1項にかかわらず、本サービスが本質的に情報の喪失、改変、破壊等の危険が内在するインターネット通信網を介したサービスであることに鑑みて、契約者又は利用者は、送信情報を自らの責任においてバックアップするものとします。当該バックアップを怠ったことによって契約者又は利用者が被った損害について、当社は、送信情報の復旧を含めて、一切責任を負いません。</li>
          <li>当社は、送信情報の開示および削除されたデータの復旧対応は行っておらず、また、送信情報の開示および復旧について、一切責任を負いません。</li>
          <li>
            <span>当社は、以下各号の一に該当する場合には、送信情報を閲覧・利用し、又は第三者へ開示することがあります。</span>
            <ol class="right-brackets">
              <li>捜査機関の令状があるとき、裁判所からの調査嘱託等開示の要求があるとき、行政機関から開示要求があるとき</li>
              <li>法律に従い開示の義務を負うとき</li>
              <li>当社が、契約者又は利用者が第21条に定める禁止事項に該当する行為をしてと判断したとき</li>
              <li>契約者、利用者又は第三者の生命・身体・その他重要な権利を保護するために必要なとき</li>
              <li>本サービスのメンテナンスのため緊急の必要があるとき</li>
              <li>上記各号に準じる必要性があるとき</li>
            </ol>
          </li>
          <li>
            <span>当社は、以下各号の一に該当する場合には、送信情報について、その一部又は全部を削除することがあります。当社は、削除された送信情報について、当該情報の復旧を含めて一切責任を負いません。</span>
            <ol class="right-brackets">
              <li>契約者の同意を得たとき</li>
              <li>利用契約が終了したとき</li>
              <li>削除する必要性があると当社が合理的に判断したとき</li>
            </ol>
          </li>
          <li>第5項および第6項の定めは、当社が同項に定める措置を実施する義務を負うものではありません。当該措置の実施の有無は、当社の任意の判断によるものとします。</li>
          <li>第18条に定める契約者による解約又は第22条に定める当社による解除により利用契約が終了した場合、当該契約の契約者および利用者のユーザー情報および送信情報は削除されます。</li>
          <li>契約者によって利用者が除外された場合、当該利用者のユーザー情報は削除されますが、当該利用者が本サービス利用中に送信した送信情報は削除されません。</li>
          <li>第8項および第9項で利用者のユーザー情報が削除された場合でも、当該利用者のユーザーアカウントは削除されません。当該利用者はそのユーザーアカウントで他の契約の契約者又は利用者になることができます。</li>
        </ol>
      </div>
    </div>
    <div class="article">
      <div class="article-title">第24条（本サービス提供のあり方に関する合意事項）</div>
      <div class="article-body">
        <ol>
          <li>
            <span>当社は、本サービスを、現状有姿の状態で提供します。当社は、次の各号につき、いかなる保証も行うものではありません。さらに、契約者が当社から直接又は間接に、本サービスに関する情報を得た場合であっても、当社は、契約者に対し、本利用規約において規定されている内容を超えて、いかなる保証も行うものではありません。</span>
            <ol class="right-brackets">
              <li>本サービスの利用に起因して利用環境に不具合や障害が生じないこと</li>
              <li>本サービスの正確性、完全性、永続性、目的適合性、有用性</li>
              <li>契約者に適用のある法令、業界団体の内部規則等への適合性</li>
            </ol>
          </li>
          <li>当社は、本サービスを、ＳＳＬ通信による暗号化の下提供いたします。契約者は、このセキュリティレベルについて了解するものとします。</li>
          <li>当社は、契約者が本サービスを利用して行うチャットやアップロードされるファイルについて、一切監視の責任を負いません。</li>
        </ol>
      </div>
    </div>
    <div class="article">
      <div class="article-title">第25条（免責事項）</div>
      <div class="article-body">
        <ol>
          <li>契約者又は利用者のユーザーＩＤおよびパスワードが第三者によって使用されていた場合、契約者又は利用者が被った損害について、契約者又は利用者の故意や過失の有無にかかわらず、当社は一切責任を負いません。</li>
          <li>第三者によるクレジットカード不正利用が行われた場合、契約者と、第三者およびクレジットカード会社との間で処理解決するものとし、契約者の故意過失の有無にかかわらず、当社は一切責任を負いません。</li>
          <li>契約者とクレジットカード会社、収納代行会社、その他金融機関などの間で紛争が発生した場合は、当該当事者双方で解決するものとし、当社は一切責任を負いません。</li>
          <li>第15条の規定によるサービス中断期間中、契約者が本サービスを利用できなかったことに関する損害、作業が中断したことに関する損害、データが失われたことに関する損害、本サービスを利用することによって得られたであろう利益を得られなかった損害など、本サービスの利用に際して発生した損害については、直接損害・間接損害、現実に発生した損害か否かを問わず、当社は一切の責任を負わないものとし、契約者はこれを承諾するものとします。</li>
          <li>第16条の規定によるサービス停止期間中、契約者が本サービスを利用できなかったことに関する損害、作業が中断したことに関する損害、データが失われたことに関する損害、本サービスを利用することによって得られたであろう利益を得られなかった損害など、本サービスの利用に際して発生した損害については、直接損害・間接損害、現実に発生した損害か否かを問わず、当社は一切の責任を負わないものとし、契約者はこれを承諾するものとします。</li>
          <li>第17条の規定によって本サービスが廃止された場合、お客様が本サービスを利用できなくなったことに関する損害、作業が中断したことに関する損害、データが失われたことに関する損害、本サービスを利用することによって得られたであろう利益を得られなかった損害など、本サービスの利用に際して発生した損害については、直接損害・間接損害、現実に発生した損害か否かを問わず、当社は一切の責任を負わないものとし、契約者はこれを承諾するものとします。</li>
          <li>サービス提供期間中に発生した天災等の不慮の事故によるサービスの停止につきましては、当社はいかなる責任も負わないものとします。</li>
        </ol>
      </div>
    </div>
    <div class="article">
      <div class="article-title">第26条（責任の制限）</div>
      <div class="article-body">
        <ol>
          <li>本利用規約における当社の各免責規定は、当社に故意又は重過失が存在する場合には適用しません。ただし、フリープラン契約については、この限りでありません。</li>
          <li>当社が損害賠償責任を負う場合（前項の場合又は消費者契約法その他の法律の適用による場合等）、賠償すべき損害の範囲は、契約者に現実に発生した直接かつ通常生じる範囲内の損害に限るものとし、逸失利益を含むその他の特別損害については責任を負いません。また、その賠償額は、当該損害発生時までに当該利用契約の契約者が当社に支払った利用料金（1ヶ月の利用料金を限度とする）とします。</li>
        </ol>
      </div>
    </div>
    <div class="article">
      <div class="article-title">第27条（紛争処理および損害賠償）</div>
      <div class="article-body">契約者は、契約者又は利用者が本サービスの利用により当社又は第三者に対し損害を与え、紛争となった場合（契約者が本利用規約上の義務を履行しないことにより当社又は第三者が損害を被った場合を含む）は、自己の責任と費用をもって、当該紛争を処理するとともに、かかる損害を賠償するものとします。</div>
    </div>
    <div class="article">
      <div class="article-title">第28条（秘密保持）</div>
      <div class="article-body">契約者は、本サービスに関連して当社が契約者に対して秘密に扱うことを指定して開示した情報について、当社の事前の書面による承諾がある場合を除き、開示目的以外に利用せず、また、第三者に開示しないものとします。</div>
    </div>
    <div class="article">
      <div class="article-title">第29条（分離可能性）</div>
      <div class="article-body">本利用規約の規定の一部が法令又は裁判所により違法、無効又は不能であるとされた場合においても、本利用規約のその他の規定は有効に存続します。</div>
    </div>
    <div class="article">
      <div class="article-title">第30条（準拠法）</div>
      <div class="article-body">本利用規約の成立、効力、履行および解釈には、日本法が適用されるものとします。</div>
    </div>
    <div class="article">
      <div class="article-title">第31条（専属的合意管轄）</div>
      <div class="article-body">本利用規約に関わる紛争については、東京地方裁判所又は東京簡易裁判所を第一審の専属的合意管轄裁判所とします。</div>
    </div>
    <div class="article">
      <div class="article-title">第32条（協議）</div>
      <div class="article-body">本サービスに関して契約者と当社との間で問題が生じた場合、契約者と当社は誠意をもって協議し、その解決に努めるものとします。</div>
    </div>
    <div class="terms-of-service-footer">以上</div>
  </div>
</template>

<script>
export default {
  name: 'TermsOfServiceContent',
  props: {
    sm: Boolean
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/mediaquery";

.terms-of-service-content {
  font-size: 14px;
  line-height: 1.8em;

  @include mq(md) {
    font-size: 16px;
  }

  .heading {
    text-align: center;
    font-size: 1.5em;
    font-weight: 600;
    line-height: 1.3em;
    margin-bottom: 60px;

    @include mq(md) {
      font-size: 2em;
    }
  }

  &.sm {
    font-size: 12px;
    line-height: 1.6em;

    @include mq(md) {
      font-size: 14px;
    }

    .heading {
      font-size: 1.4em;
      line-height: 1.3em;
      margin-bottom: 40px;

      @include mq(md) {
        font-size: 1.6em;
      }
    }
  }
}

.article {
  margin-bottom: 20px;

  .article-title {
    font-weight: 600;
  }

  .article-body {
    padding-left: 14px;

    ol {
      padding-left: 16px;
      counter-reset: cnt;

      &.right-brackets {
        list-style-type: none;
        padding-left: 32px;

        > li::before {
          counter-increment: cnt;
          content: counter(cnt) ")";
          width: 32px;
          margin-left: -32px;
          display: inline-block;
        }
      }
    }
  }
}

.terms-of-service-footer  {
  text-align: right;
  margin-top: 80px;
}
</style>
